// src/account-deletion/accountDeletionApi.ts
import { apiClient } from "@maat/api-base";
var accountDeletionApi = {
  /** What (if anything) stands between the current user and deletion. */
  getBlockers: async () => {
    return await apiClient.get(
      "/main/api/users/me/account-deletion/blockers"
    );
  },
  /** Open the 30-day grace window (re-auth proof in the body). Signs the caller out. */
  requestDeletion: async (data) => {
    return await apiClient.post(
      "/main/api/users/me/account-deletion",
      data
    );
  },
  /** Cancel a pending deletion with the token from the login discriminator; mints a session. */
  restoreAccount: async (data) => {
    return await apiClient.post(
      "/main/api/auth/account-deletion/restore",
      data
    );
  }
};

export {
  accountDeletionApi
};
